import React from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { Link } from "react-router-dom";
import { formatDate } from "../../utils";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const Courses = {
  1: "Maths",
  2: "Science",
  3: "Physics",
  4: "Chemistry",
};

const ParseSubject = (value) => {
  return Courses[value];
};

const CustomHeader = ({ date, onDownload }) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <span>{formatDate(new Date(date))}</span>
    <i 
      className="bi bi-file-earmark-arrow-down-fill"
      onClick={onDownload} 
      style={{ marginLeft: '5px', cursor: 'pointer' }} 
      title="Download"
    />
  </div>
);

const StudentMarksTable = ({ data }) => {
  const sortedData = JSON.parse(JSON.stringify(data));
  
  sortedData.students.forEach((student) => {
    student.marksDetails.sort((a, b) => new Date(b.dateofExam) - new Date(a.dateofExam));
  });

  const dates = sortedData.students[0].marksDetails.map((item) => item.dateofExam);
  
  const columnDefs = [
    {
      headerName: "Student Name",
      field: "studentName",
      cellRenderer: (params) => (
        <Link to={`/studentDashboard/${params.data.studentId}`}>
          {params.data.studentName}
        </Link>
      ),
    },
    { headerName: "Class", field: "class", filter: false , sortable: false },
    { headerName: "Subject", field: "subject", filter: false , sortable: false },
    ...dates.map((date, index) => ({
      headerComponent: (props) => <CustomHeader date={date} onDownload={() => downloadPDF(date)} />,
      field: `marksDetail_${index}`,
    })),
  ];

  const rowData = sortedData.students.map((student) => {
    const studentData = {
      studentId: student.studentId,
      studentName: student.studentName,
      class: data.class,
      subject: ParseSubject(data.courses),
    };
    student.marksDetails.forEach((marksDetail, index) => {
      studentData[`marksDetail_${index}`] = marksDetail.marks;
    });
    return studentData;
  });

  const downloadPDF = (date) => {
    const pdf = new jsPDF();

    const formattedDate = formatDate(new Date(date)).replace(/\//g, "-");
    const pdfName = `class${data.class}_${ParseSubject(data.courses)}_${formattedDate}.pdf`;

    const pdfData = sortedData.students.map((student) => {
      const marks = student.marksDetails.find(m => m.dateofExam === date)?.marks;
      let maxMarks = student.marksDetails.find(m => m.dateofExam === date)?.maxMarks; 
      return { name: student.studentName, marks , maxMarks};
    });

    pdfData.sort((a, b) => b?.marks - a?.marks); // Sort by marks
    pdfData.forEach((item, index) => {
      item.rank = index + 1; // Assign rank
    });

    pdf.text(`Results for Class - ${data.class} for Test taken on Date - ${formattedDate}`, 14, 10);

    autoTable(pdf, {
      head: [['Rank', 'Name', 'Marks']],
      body: pdfData.map(item => [item.rank, item.name, `${item.marks? item.marks + '/' + item.maxMarks : 'Absent' }`]),
      startY: 20,
    });

    pdf.save(pdfName);
  };

  const onGridReady = (params) => {
    params.api.sizeColumnsToFit();
  };

  const getRowHeight = () => 30;

  return (
    <div className="ag-theme-alpine" style={{ height: 440, width: "100%" }}>
      <AgGridReact
        columnDefs={columnDefs}
        rowData={rowData}
        pagination={true}
        paginationPageSize={20}
        defaultColDef={{
          resizable: true,
          sortable: true,
          filter: true,
        }}
        animateRows={true}
        onGridReady={onGridReady}
        getRowHeight={getRowHeight}
      />
    </div>
  );
};

export default StudentMarksTable;
